import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import  {Navbar}  from "./Navbar";
import Cookies from "js-cookie"
function Home1() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    localStorage.removeItem("completedSteps")
  }, []);

  const uploadPage = () => {
    navigate("/upload");
  };

  const renderDynamicCircles = () => {
    return [...Array(10)].map((_, index) => {
      const size = Math.random() * 40 + 20; // Random size between 20 and 60px
      const top = Math.random() * 100; // Random top position
      const left = Math.random() * 100; // Random left position
      return (
        <motion.div
          key={index}
          className="absolute rounded-full bg-white opacity-40"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            top: `${top}%`,
            left: `${left}%`,
          }}
          animate={{
            y: ["0%", "100%", "0%"],
            x: ["0%", "10%", "-10%"],
          }}
          transition={{
            duration: Math.random() * 5 + 5,
            repeat: Infinity,
            ease: "easeInOut",
            delay: Math.random() * 5,
          }}
        />
      );
    });
  };

  return (
    <>
    <Navbar />
    <div className="relative mx-auto bg-gradient-to-b sm:pt-10 from-sky-300/30 to-white-300 min-h-screen px-6 sm:px-16 overflow-hidden mt-0">
      <motion.div
        className="absolute top-10 left-10 w-24 h-24 rounded-full bg-blue-400 opacity-20"
        animate={{
          x: [0, 30, -30, 0],
          y: [0, -30, 30, 0],
        }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
      ></motion.div>
      <motion.div
        className="absolute bottom-20 right-20 w-32 h-32 rounded-full bg-pink-400 opacity-20"
        animate={{
          x: [0, -40, 40, 0],
          y: [0, 40, -40, 0],
        }}
        transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
      ></motion.div>
      {renderDynamicCircles()}

      
      <div className="flex flex-col sm:flex-row items-center justify-between pt-10 sm:pt-0">
        <motion.div
          className="w-full sm:w-1/2 text-center text-black"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <div className="flex flex-col space-y-4">
            <motion.h1
              className="text-2xl sm:text-4xl font-bold"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2, delay: 0.3 }}
            >
              Get your resume job-ready in minutes and advance your career
            </motion.h1>
            <motion.p
              className="text-gray-700"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2, delay: 0.5 }}
            >
              Unlock your career potential with our intuitive resume recommendations
            </motion.p>
            <div className="flex flex-col items-center space-y-4" onClick={uploadPage}>
              <div className="flex items-center space-x-4">
                <motion.div
                  className="w-20 h-[1px] bg-gray-300"
                  initial={{ scaleX: 0 }}
                  animate={{ scaleX: 1 }}
                  transition={{ duration: 1, delay: 0.7 }}
                ></motion.div>
                <motion.h2
                  className="text-lg font-semibold text-gray-800"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 1, delay: 0.9 }}
                >
                  Get Started
                </motion.h2>
                <motion.div
                  className="w-20 h-[1px] bg-gray-300"
                  initial={{ scaleX: 0 }}
                  animate={{ scaleX: 1 }}
                  transition={{ duration: 1, delay: 0.7 }}
                ></motion.div>
              </div>
              <motion.button
                className="bg-gray-800 text-white px-6 py-2 rounded-md text-lg flex items-center space-x-2 hover:bg-gray-700 transition"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.8, delay: 1 }}
              >
                <span>Fit my resume</span>
                <span>🚀</span>
              </motion.button>
            </div>
          </div>
        </motion.div>
        <motion.div
          className="w-full sm:w-1/2 sm:pl-32"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <motion.img
            src="https://res.cloudinary.com/danm2mfq5/image/upload/v1736142954/dhdi3qybgflfzpq4yzlp.png"
            alt="Resume Illustration"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1.2, delay: 0.5 }}
          />
        </motion.div>
      </div>
      <motion.div
        className="mt-10 text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, delay: 1.5 }}
      >
      </motion.div>
    </div>
    </>
  );
}

export default Home1;
